/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ClearanceCaseLogMessageType {
  Normal = 0,
  ChangedAssignee = 1,
  Invoiced = 2,
  NotInvoiced = 3,
  ForcedStatusChanged = 4,
}
